<p-fieldset legend="Audesp - Fase 4">
    <ul class="list-group list-group-flush" style="margin-left: -1rem; margin-right: -1rem;">
        <li class="list-group-item p-1 pl-3">
            <i [class]="(entidade?.exportado ? 'fa fa-check' : 'far fa-square')"></i> Exportado
        </li>
        <li class="list-group-item p-1 pl-3">
            <i [class]="(entidade?.enviado ? 'fa fa-check' : 'far fa-square')"></i> Enviado
        </li>
        <li class="list-group-item p-1 pl-3">
            <i [class]="(entidade?.armazenado ? 'fa fa-check' : 'far fa-square')"></i> Armazenado
        </li>
    </ul>
</p-fieldset>